import React from "react";
import Layout from "../../components/Layout";
import OpenGraphTitle from "../../components/OpenGraphTitle";
import OpenGraphDescription from "../../components/OpenGraphDescription";
import Head from "../../components/head";
import { ServicesPageProvider } from "../../context/ServicesPageContext";
import { FranchiseeProvider } from "../../context/Franchisee";
import ServiceTitle from "../../components/ServiceTitle";
import ServicesDescription from "../../components/ServicesDescription";
import { Col, Row } from "react-bootstrap";
import Link from "next/link";
import ContactUs from "../../components/ContactUs";

interface DeepCleanPageProps {
  /* add services page props here */
}

const DeepClean: React.FC<DeepCleanPageProps> = () => (
  <FranchiseeProvider>
    <ServicesPageProvider>
      <Layout alternateFooter={true}>
        <Head
          slug="deep-clean"
          title="Professional Deep Cleaning Services - Two Maids"
          description="Our professional Deep Cleaning Services tackle the overlooked areas of the home, making it sparkle like it’s brand new."
        />
        <OpenGraphTitle title="Professional Deep Cleaning Services - Two Maids" />

        <OpenGraphDescription>
          Our professional Deep Cleaning Services tackle the overlooked areas of the home, making it sparkle like it’s brand new.
        </OpenGraphDescription>

        <ServiceTitle imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955999/hubsite-reskin/New%20Services%20Pages/deep-cleaning.webp">Deep Cleaning</ServiceTitle>
        <div className="service-description gray-background">
          <Row className="pb-3">
            <Col md={12} lg={5}>
              <h2>Professional Deep Cleaning Services</h2>
              <p>
                When it comes to choosing from our 
                cleaning service packages, we always 
                recommend starting things off with a good 
                Deep Clean to tackle any long-standing 
                build-up. With our busy lives, it can be hard 
                to find time to get into the details. 
                Thankfully, that's what Two Maids is here for.
              </p>
            </Col>
            <Col md={12} lg={7}>
              <h3 className="service-description-title"><b>What's Included in Professional Deep Cleaning Services?</b></h3>
              <p>
                <b className="gotham-bold">Kitchen Care:</b> We clean the inside/outside of the microwave and oven, and polish 
                the outside of the refrigerator and other appliances. We also clean the countertops, 
                sinks, fixtures, exterior of the stove hood, and backsplash.
              </p>
              <p>
                <b className="gotham-bold">Bathroom Brilliance:</b> Shower and bathtubs, faucets, toilets, and sinks often need 
                more than the run-of-the-mill regular cleaning. We take care of that for you.
              </p>
              <p>
                <b className="gotham-bold">Living Room and Bedroom Areas:</b> We dust furniture, make beds, change linens, 
                and vacuum carpets and rugs.
              </p>
              <p>
                <b className="gotham-bold">Throughout the Home:</b> We clean glass surfaces, empty trash, replace liners, dust 
                ceiling fans, light fixtures, and air vents. We also clean light switches and outlet 
                covers, and expertly tackle cobwebs. To do away with dirt, we provide floor cleaning, 
                and sweep and mop floors that get grubby from everyday life.
              </p>
            </Col>
          </Row>
        </div>
        <ServicesDescription colSize={12}>
          <div className="d-flex flex-wrap-deep-clean">
            <div>
              <h3 className="service-description-title">Why Start with a Deep Clean?</h3>
              <p>
                Maintaining a clean home environment begins with tackling the grime that accumulates over 
                time, setting the stage for regular upkeep. Our Deep Cleaning service is designed to do just 
                that. As our most thorough house cleaning service available, the biggest difference between 
                the Deep Cleaning package and our other standard cleaning packages is the amount of time 
                and detail we spend cleaning what we refer to as your vertical surfaces.
              </p>
            </div>
            <div className="gray-background vertical-surfaces">
              <h3 className="service-description-title"><i>Vertical Surfaces:</i></h3>
              <ul>
                <li>Baseboards</li>
                <li>Trim work</li>
                <li>Interior windows & blinds</li>
                <li>Exterior cabinets & drawers</li>
                <li>Light Fixtures</li>
                <li>Doors</li>
              </ul>
            </div>
          </div>
        </ServicesDescription>
        <div className="service-description promise-description pt-0">
          <img className="service-description-section-promise-svg mr-3" src="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955994/hubsite-reskin/New%20Services%20Pages/promise.svg" />
          <div>
            <h3 className="service-description-title">Our Promise to You</h3>
            <p>
              With our maid service, you'll know that you're selecting a partner to transform your space into a clean 
              and fresh environment, providing you with the freedom to enjoy your home to its fullest.
            </p>
          </div>
        </div>
        <ContactUs 
          title="Ready for a Fresh Start?"
          buttons={
            <Row className="d-flex justify-content-start">
              <Col md={"auto"} className="mb-3">
                <Link href={process.env.SALES_FUNNEL_URL}>
                  <a className="contact-us-button">BOOK YOUR CLEANING</a>
                </Link>
              </Col>
              <Col md={"auto"}>
                <Link href={process.env.SALES_FUNNEL_URL}>
                  <a className="contact-us-button">CALCULATE YOUR PRICE</a>
                </Link>
              </Col>
            </Row>
          }
        >
          <p>
            Whether you're overwhelmed by daily responsibilities, struggling to 
            find time for yourself, or simply in need of a deep refresh, our 
            Professional Deep Cleaning Service is the first step toward reclaiming 
            your space. Let Two Maids help you transition into a new season of 
            life: sparkly, clean, and with a clear mind.
          </p>
        </ContactUs>
      </Layout>
    </ServicesPageProvider>
  </FranchiseeProvider>
);
export default DeepClean;